var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.5,
    viewBox: "0 0 20 17.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "camera",
    d: "M7.465,32a1.87,1.87,0,0,0-1.777,1.281L5.277,34.5H2.5A2.5,2.5,0,0,0,0,37V47a2.5,2.5,0,0,0,2.5,2.5h15A2.5,2.5,0,0,0,20,47V37a2.5,2.5,0,0,0-2.5-2.5H14.723l-.406-1.219A1.878,1.878,0,0,0,12.535,32Zm-.594,1.676a.627.627,0,0,1,.594-.426h5.07a.627.627,0,0,1,.594.426l.547,1.645a.627.627,0,0,0,.594.426H17.5A1.249,1.249,0,0,1,18.75,37V47a1.249,1.249,0,0,1-1.25,1.25H2.5A1.249,1.249,0,0,1,1.25,47V37A1.249,1.249,0,0,1,2.5,35.75H5.73a.627.627,0,0,0,.594-.426l.547-1.645ZM10,46.375A4.375,4.375,0,1,0,5.625,42,4.375,4.375,0,0,0,10,46.375ZM6.875,42A3.125,3.125,0,1,1,10,45.125,3.125,3.125,0,0,1,6.875,42Z",
    transform: "translate(0 -32)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.e6e4418ec1e23b643a788b7ac7c3ab27.svg";